(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .controller('MateriaDeleteController', MateriaDeleteController);

            MateriaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Materia'];

    function MateriaDeleteController($uibModalInstance, entity, Materia) {
        var vm = this;

        vm.materia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Materia.delete({id: id},
                    function () {
                        $uibModalInstance.close(true);
                    });
        }
    }
})();
